<template>
  <v-dialog
    v-model="dialog"
    max-width="420px"
  >
    <v-card
      class="pa-4"
      elevation="8"
      rounded="xl"
      color="#fff"
    >
      <!-- Header -->
      <div class="d-flex justify-space-between align-center mb-3">
        <h3 class="text-h6 font-weight-bold">
          Check In
        </h3>
        <v-btn
          icon
          light
          @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-form
        ref="form"
        v-model="valid"
      >
        <v-select
          v-model="selectedProject"
          :items="projects"
          item-text="name"
          item-value="id"
          light
          label="Select Project"
          outlined
          dense
          :rules="[(v) => !!v || 'Project is required']"
        />

        <v-radio-group
          v-model="selectedDateOption"
          row
          dense
          hide-details
          class="mb-3"
          @change="handleDateChange"
        >
          <v-radio
            label="Today"
            value="today"
            color="#37474F"
            light
          />
          <v-radio
            label="Yesterday"
            value="yesterday"
            color="#37474F"
            light
          />
        </v-radio-group>

        <v-text-field
          v-model="time"
          label="Select Time"
          placeholder="hh:mm AM/PM"
          outlined
          dense
          light
          class="mb-4"
          :rules="[validateTime, validateNotFuture]"
          @input="handleTimeInput"
          @blur="formatTime"
        />
      </v-form>

      <div class="d-flex justify-end">
        <v-btn
          text
          color="#37474F"
          small
          class="mr-2"
          @click="closeDialog"
        >
          Cancel
        </v-btn>

        <v-btn
          color="#2E7D32"
          dark
          small
          @click="handleCheckin"
        >
          Check In
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import Constants from 'src/constants';

export default {
  name: 'CheckinPopUp',

  props: {
    show: Boolean,
    projects: {
      type: Array,
      default: () => [],
    },
    userId: {
      type: String,
      default: '',
    },
    orgExtId: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      dialog: true,
      selectedProject: null,
      date: moment().format('YYYY-MM-DD'),
      time: moment().format('hh:mm A'),
      selectedDateOption: 'today',
      valid: false,
    };
  },

  computed: {
    isToday () {
      return this.date === moment().format('YYYY-MM-DD');
    },
  },

  watch: {
    projects: {
      immediate: true,
      handler (val) {
        if (val && val.length === 1) {
          this.selectedProject = val[0].id;
        }
      },
    },
  },

  methods: {
    closeDialog () {
      this.dialog = false;
      this.$emit('close');
    },

    validateTime (value) {
      if (!value) return 'Time is required';

      const isValid = moment(value, 'hh:mm A', true).isValid();
      return isValid || 'Invalid time format (e.g., 02:30 PM)';
    },
    handleDateChange () {
  this.date =
    this.selectedDateOption === 'today'
      ? moment().format('YYYY-MM-DD')
      : moment().subtract(1, 'day').format('YYYY-MM-DD');
},
    handleTimeInput (value) {
      if (!value) return;
      let period = value.match(/am|pm/i);
      period = period ? period[0].toUpperCase() : '';
      const cleaned = value.replace(/[^\d]/g, '').substring(0, 4);

      let formatted = '';

      if (cleaned.length >= 3) {
        formatted = cleaned.substring(0, 2) + ':' + cleaned.substring(2);
      } else {
        formatted = cleaned;
      }

      if (period) {
        formatted += ' ' + period;
      }

      this.time = formatted.trim();
    },
    formatTime () {
      if (!this.time) return;

      const m = moment(this.time, ['HH:mm', 'H:mm', 'hh:mm A'], true);

      if (m.isValid()) {
        this.time = m.format('hh:mm A');
      }
    },
    validateNotFuture (value) {
      if (!value) return true;

      const selected = moment(`${this.date} ${value}`, 'YYYY-MM-DD hh:mm A');

      if (selected.isAfter(moment())) {
        return 'Future time not allowed';
      }

      return true;
    },
    handleCheckin () {
      if (!this.$refs.form.validate()) return;

      const localDateTime = moment(
        `${this.date} ${this.time}`,
        'YYYY-MM-DD hh:mm A',
      );

      this.$store
        .dispatch('swiftuser/checkInUser', {
          orgExtId: this.orgExtId,
          details: {
            project_id: this.selectedProject,
            checkin_time: localDateTime.utc().format(),
            location_id: null,
            type: 'worker',
            app_user_id: this.userId,
            checkin_method_type: 'admin-checkin',
          },
        })
        .then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Check-in completed successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
        })
        .catch((error) => {
          this.$store.dispatch('alert/onAlert', {
            message: `${error.response.data.message}`,
            type: Constants.ALERT_TYPE_ERROR,
          });
        });

      this.closeDialog();
    },
  },
};
</script>

<style scoped>
::v-deep .v-input--selection-controls__input .v-icon {
  color: rgb(8, 8, 8) !important;
}

.v-list-item__title {
  color: #0000 !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}
.v-input--selection-controls {
  margin-top: 0px!important;
}
</style>
